import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { Pencil, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";

const config = {
  modelName: "customer",
  modelPluralName: "customers",
  endpoint: "customers",
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "name",
        label: "name",
        key: "name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "surnames",
        label: "surnames",
        key: "surnames",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "nif",
        label: "nif",
        key: "nif",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "email",
        label: "email",
        key: "email",
        type: "string",
        show: true,
        allowOrder: true,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      // Name
      name: {
        type: "string",
        title: t("name"),
      },
      // Surnames
      surnames: {
        type: "string",
        title: t("surnames"),
      },
      // Phone
      phone: {
        type: "string",
        title: t("phone"),
      },
      // Mobile
      mobile: {
        type: ["string", "null"],
        title: t("mobile"),
      },
      // Email
      email: {
        type: ["string", "null"],
        title: t("email"),
      },
      // NIF
      nif: {
        type: "string",
        title: t("nif"),
      },
      // Address
      address: {
        type: ["string", "null"],
        title: t("address"),
      },
      // City
      city: {
        type: ["string", "null"],
        title: t("city"),
      },
      // State
      state: {
        type: ["string", "null"],
        title: t("state"),
      },
      // Postal code
      postal_code: {
        type: ["string", "null"],
        title: t("postal_code"),
      },
      // Observations
      observations: {
        type: ["string", "null"],
        title: t("observations"),
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    observations: {
      "ui:widget": "textarea",
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "name",
              cols: "col-12",
            },
            {
              name: "surnames",
              cols: "col-12",
            },
            {
              name: "phone",
              cols: "col-6",
            },
            {
              name: "mobile",
              cols: "col-6",
            },
            {
              name: "email",
              cols: "col-6",
            },
            {
              name: "nif",
              cols: "col-6",
            },
            {
              name: "address",
              cols: "col-12",
            },
            {
              name: "city",
              cols: "col-6",
            },
            {
              name: "state",
              cols: "col-6",
            },
            {
              name: "postal_code",
              cols: "col-6",
            },
            {
              name: "observations",
              cols: "col-12",
            },
          ],
        ],
      },
    ],
  },
};
export default config;
